export const getApiHost = () => {
    return process.env.REACT_APP_API_HOST;
}

export const FormatJSONString = (value: string | undefined) => {
    if(!value){
        return "{}";
    }

    return JSON.stringify(JSON.parse(value), null, 4)
}